import { AjaxHelper, IKeyValue, getToken, IPaginatedList } from "@samc/common";
import { IForwardCommitment, IPackageMilestones, ITaskTypeTemplate, ILoanDealAllocation, ILoanKickResultsRequest } from "../Interfaces";

export class TransactionService {
  private _helper: AjaxHelper;

  public constructor(verificationToken: string | null) {
    this._helper = new AjaxHelper('/componentapi/transaction', verificationToken, null, getToken());
  }

  public async upsert(forwardCommitment: IForwardCommitment): Promise<IForwardCommitment> {
    return await this._helper.postData<IForwardCommitment>('/forwardcommitment', forwardCommitment);
  }

  public async addForwardCommitmentConnection(packageId: number, forwardId: number): Promise<number> {
    return await this._helper.postData<number>(`/forwardcommitment/${packageId}`, {}, { forwardId });
  }

  public async removeForwardCommitmentConnection(packageId: number): Promise<boolean> {
    return await this._helper.delete<boolean>(`/forwardcommitment/${packageId}`);
  }

  public async getForwardCommitment(packageId: number): Promise<IForwardCommitment> {
    return await this._helper.getData<IForwardCommitment>(`/forwardcommitment/${packageId}`);
  }

  public async getForwardCommitments(): Promise<IKeyValue<string, number>> {
    return await this._helper.getData<IKeyValue<string, number>>('/forwardcommitment');
  }

  //milestones

  public async deleteMilestone(milestoneId: number): Promise<boolean> {
    return await this._helper.delete<boolean>(`/milestone/${milestoneId}`);
  }

  public async getMilestone(milestoneId: number): Promise<IPackageMilestones> {
    return await this._helper.getData<IPackageMilestones>(`/milestone/${milestoneId}`);
  }

  public async updateMilestone(milestone: IPackageMilestones): Promise<boolean> {
    return await this._helper.postData<boolean>('/milestone', milestone);
  }

  public async getMilestonebyName(id: string, milestoneId:number, milestoneName: string): Promise<IPackageMilestones> {
    return await this._helper.getData<IPackageMilestones>(`/package/${id}/milestone/${milestoneId}`, { milestoneName });
  }

  public async kickOffPackageLoans(packageId: string, description: string, kickedOffLoans: number[]): Promise<ILoanKickResultsRequest> {
    return await this._helper.postData<ILoanKickResultsRequest>('/buypackages/kickoffloans', { packageId, description, kickedOffLoans });
  }

  public async kickOffPackageLoansRemoveDeals(packageId: string, description: string, kickedOffLoans: number[]): Promise<ILoanKickResultsRequest> {
    return await this._helper.postData<ILoanKickResultsRequest>('/buypackages/kickoffloans/removefromdeals', { packageId, description, kickedOffLoans });
  }

  public async getDealsForLoans(loanIds: number[]): Promise<ILoanDealAllocation[]> {
    return await this._helper.postData<ILoanDealAllocation[]>('/deals/loans/whatdeals', { loanIds });
  }

  public async getDealsForLoansExport(loanIds: number[]): Promise<Blob> {
    return await this._helper.postData<Blob>('/deals/loans/whatdeals/export', { loanIds }, {}, { responseType: 'blob' });
  }

  /**
   * Gets the list of task templates
   * 
   * @param pageSize Optional page size (defaults to 100)
   * @param pageNumber Optional page number (defaults to 1)
   * @returns Will return a paginated list of task templates
   */
  public async getTemplates(pageSize: number = 100, pageNumber: number = 1): Promise<IPaginatedList<ITaskTypeTemplate>> {
    return await this._helper.getData<IPaginatedList<ITaskTypeTemplate>>('/templates', { pageSize, pageNumber });
  }

}